import { Pipe, PipeTransform } from '@angular/core';
declare function require(name: string);

type SlugFn = (value: string) => string;

@Pipe({
  name: 'name2slug',
  standalone: false,
})
export class Name2SlugPipe implements PipeTransform {
  private readonly _slug: SlugFn;

  constructor() {
    this._slug = require('slug'); // ???
  }

  public transform(value: string): string {
    return this._slug(value);
  }
}
